import type {Linking} from 'schema/types';

export const mergeLinkingConfigurations = (
  fieldConfig?: Linking,
  pageConfig?: Linking,
): Linking | undefined => {
  if (!fieldConfig && !pageConfig) {
    return undefined;
  }

  return {
    ...pageConfig,
    ...fieldConfig,
  } as Linking;
};
